/** Last pointer Y inside this frame (iframe or top window). Used to place overlays where the user is looking. */
let lastInteractionClientY: number | null = null;
let trackingStarted = false;

function readClientY(event: Event): number | null {
    if (event instanceof PointerEvent || event instanceof MouseEvent) {
        return event.clientY;
    }
    if (event instanceof TouchEvent && event.touches.length > 0) {
        return event.touches[0].clientY;
    }
    return null;
}

/** Call once from app bootstrap / toastr init so click-Y is always available. */
export function startViewportInteractionTracking() {
    if (trackingStarted || typeof window === "undefined") return;
    trackingStarted = true;

    const update = (event: Event) => {
        const y = readClientY(event);
        if (y != null) lastInteractionClientY = y;
    };

    window.addEventListener("pointerdown", update, true);
    window.addEventListener("click", update, true);
}

/** Prefer last click/tap; fall back to middle of this window. */
export function getVisibleOverlayTopPx(overlayHeight = 80): number {
    const fallbackY = typeof window !== "undefined" ? window.innerHeight / 2 : 200;
    const y = lastInteractionClientY ?? fallbackY;
    return Math.max(16, y - overlayHeight / 2);
}

/**
 * Positions a fixed overlay (e.g. #mini-toastr) at the user's last interaction Y.
 * Critical for auto-height iframe embeds: default top:12px is often scrolled out of the parent viewport.
 */
export function positionFixedOverlayInView(el: HTMLElement | null) {
    if (!el) return;

    const height = el.offsetHeight || 80;
    const top = getVisibleOverlayTopPx(height);

    el.style.setProperty("position", "fixed", "important");
    el.style.setProperty("top", `${top}px`, "important");
    el.style.setProperty("left", "50%", "important");
    el.style.setProperty("right", "auto", "important");
    el.style.setProperty("bottom", "auto", "important");
    el.style.setProperty("transform", "translateX(-50%)", "important");
    el.style.setProperty("z-index", "99999", "important");
    el.style.setProperty("width", "fit-content", "important");
    el.style.setProperty("max-width", "min(520px, calc(100vw - 24px))", "important");
}
